import EngineModule from '../../../EngineModule';
import { NS as StandingCarpetImprintNS } from '../../../components/customers/standing/StandingCarpetImprint/StandingCarpetImprint';
export default () => new EngineModule.LogicalEngineModule({
	type :             'logical',
	id :               'standing-carpetImprint',
	dependencies :     [
		'oms-basket',
		'viewer-planner',
		'viewer-planner-layout-editor',
		'viewer-planner-dimensionsEditor'
	],
	allowedCustomers : [ /* Local MPA */'XUJG0A2TF5', /* Prod */'STAODAZNIS' , 'sam1_12345'],
	insertionPath :    'K',
	generateComponentConfiguration() : StandingCarpetImprintNS.Configuration {
		return {

		};
	},
	async initialize() {
	}
});
